import { node, icon } from "~/util/dom";
import { ISubscriptionWithDescription } from "~/util/providers/share-position/interfaces";
import createSDSIcon from "~/ui/icon";
import { CLOSE_24 } from "@sznds/icons";
import { FINNISH_16 } from "~/util/sds-compatible-icons";
import { timePosition } from "~/util/format";
import { criterionToTypeIcon } from "~/util/route";

// po jake dobe bez dat si zaciname myslet, ze mame jen pravdepodobna cisla
const TIMEOUT = 5 * 60000;

// eslint-disable-next-line id-length
export function createSubscriptionTextInfo(subscription: ISubscriptionWithDescription, lang: string, _: (keyInput: string, ...rest: any[]) => string): HTMLDivElement {
	const text = node("div", { className: "ui-sp-subscription-text" });
	const name = node("h2", { innerText: subscription.user.name });

	text.appendChild(name);

	// uzivatel jel a urcite dojel (podle appky)
	if (subscription.routeInfo?.destinationReached) {
		const positionDate = new Date(subscription.positionTime);
		const para = node("p", { className: "ui-sp-subscription-text--status" });
		const updated = node("p", { innerText: `${_("sharePosition.textUpdated")} ${timePosition(positionDate).toLocaleLowerCase()}` });
		const title = subscription.routeParts?.length
			? subscription.routeParts[subscription.routeParts.length - 1].poi?.description?.titleVars?.titleMain || subscription.routeParts[subscription.routeParts.length - 1].poi?.description?.title
			: "";
		const poi = node("p", { innerText: title });
		const span = node("span", { innerHTML: `${_("sharePosition.textExpired")} <em>(${timePosition(positionDate).toLocaleLowerCase()})</em>` });
		const finnish = createSDSIcon({ symbol: FINNISH_16 });

		para.appendChild(finnish);
		para.appendChild(span);

		text.appendChild(updated);
		text.appendChild(poi);
		text.appendChild(para);
		text.classList.add("ui-sp-subscription-text--expired");
	// uzivatel stale jede
	} else if (subscription.sharingStatus === "active") {
		const positionDate = new Date(subscription.positionTime);
		const updated = node("p", { innerText: `${_("sharePosition.textUpdated")} ${timePosition(positionDate).toLocaleLowerCase()}` });

		text.appendChild(updated);

		if (subscription.routeInfo) {
			const title = subscription.routeParts?.length
				? subscription.routeParts[subscription.routeParts.length - 1].poi?.description?.titleVars?.titleMain || subscription.routeParts[subscription.routeParts.length - 1].poi?.description?.title
				: "";
			const poi = node("p", { innerText: title });
			const arrivalDate = new Date(subscription.routeInfo?.arrivalTime);
			const enroute = node("p", {
				className: "ui-sp-subscription-text--status",
				innerHTML: positionDate.getTime() + TIMEOUT >= new Date().getTime()
					? `<span><em>${_("sharePosition.enRoute")}</em> ${_("sharePosition.arrival")} <strong>${timePosition(arrivalDate).toLocaleLowerCase()}</strong> (${new Intl.DateTimeFormat(lang, { hour: "numeric", minute: "numeric" }).format(arrivalDate)})</span>`
					: `<span><em>${_("sharePosition.enRoute")}</em> ${_("sharePosition.estimatedArrival")} ${timePosition(arrivalDate).toLocaleLowerCase()}</span>`,
			});

			if (subscription.routeParts?.length) {
				enroute.prepend(icon(criterionToTypeIcon(subscription.routeParts[subscription.routeInfo.routeIndex].routeSettings.criterion)));
			}

			text.appendChild(poi);
			text.appendChild(enroute);
		}

		text.classList.add("ui-sp-subscription-text--active");
	// expirovalo znamena, ze si myslime, ze dojel do cile, ale nevime to jiste
	} else if (subscription.sharingStatus === "expired") {
		const positionDate = new Date(subscription.positionTime);
		const updated = node("p", { innerText: `${_("sharePosition.textUpdated")} ${timePosition(positionDate).toLocaleLowerCase()}` });

		text.appendChild(updated);
		text.classList.add("ui-sp-subscription-text--expired");

		if (subscription.routeInfo) {
			const para = node("p", { className: "ui-sp-subscription-text--status" });
			const title = subscription.routeParts?.length
				? subscription.routeParts[subscription.routeParts.length - 1].poi?.description?.titleVars?.titleMain || subscription.routeParts[subscription.routeParts.length - 1].poi?.description?.title
				: "";
			const poi = node("p", { innerText: title });
			const arrivalDate = new Date(subscription.routeInfo?.arrivalTime);
			const span = node("span", { innerHTML: `${_("sharePosition.estimatedArrival")} ${timePosition(arrivalDate).toLocaleLowerCase()}` });
			const finnish = createSDSIcon({ symbol: FINNISH_16 });

			para.appendChild(finnish);
			para.appendChild(span);

			text.appendChild(poi);
			text.appendChild(para);
		}
	// ukoncil to sdilejici
	} else {
		const positionDate = new Date(subscription.positionTime);
		const para = node("p", { className: "ui-sp-subscription-text--status" });
		const span = node("span", { innerHTML: `${_("sharePosition.textCanceled")} <em>${timePosition(positionDate).toLocaleLowerCase()}</em>` });
		const close = createSDSIcon({ symbol: CLOSE_24 });

		para.appendChild(close);
		para.appendChild(span);

		text.appendChild(para);
		text.classList.add("ui-sp-subscription-text--canceled");
	}

	return text;
}
